import { Button } from '@carbon/react';
import { OpenPanelFilledLeft, OpenPanelLeft } from '@carbon/react/icons';

interface FilterPanelToggleProps {
  isOpen: boolean;
  /** Read once any filter is set; without it the toggle only reads Hide/Show. */
  filterCount?: number;
  onToggle: () => void;
  /** Matches the toolbar the toggle sits in. */
  size?: 'md' | 'lg';
}

/**
 * Shows or hides a CollapsibleFilterPanel.
 * @param {FilterPanelToggleProps} props The toggle.
 * @return {JSX.Element} The toggle.
 */
export function FilterPanelToggle({
  isOpen,
  filterCount,
  onToggle,
  size = 'lg',
}: FilterPanelToggleProps) {
  const showHide = isOpen ? 'Hide Filters' : 'Show Filters';
  let text = showHide;
  if (filterCount !== undefined && filterCount > 0) {
    text =
      filterCount === 1 ? '1 Filter Applied' : `${filterCount} Filters Applied`;
  }

  return (
    <Button
      kind="ghost"
      size={size}
      onClick={onToggle}
      aria-label={isOpen ? 'Hide filters' : 'Show filters'}
      renderIcon={
        isOpen || filterCount === undefined
          ? OpenPanelFilledLeft
          : OpenPanelLeft
      }
    >
      {text}
    </Button>
  );
}
